export const formatDateInput = (input: string): string => {
  let value = input.replace(/\s+/g, '').replace(/\//g, ''); // Remove spaces and slashes
  value = value.replace(/\D/g, ''); // Remove all non-numeric characters

  // Apply formatting for MM / DD / YYYY
  if (value.length > 2) {
    value = `${value.slice(0, 2)} / ${value.slice(2)}`;
  }
  if (value.length > 7) {
    value = `${value.slice(0, 7)} / ${value.slice(7)}`;
  }

  return value.slice(0, 14); // Limit to 14 characters (including spaces and slashes)
};
